export default "__VITE_ASSET__ChWmwgX4__"